import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
/**
 * StreamingText component that displays text in real-time
 * Shows natural streaming effect as chunks arrive from Claude API
 *
 * Like ChatGPT/Claude - text appears chunk-by-chunk as it streams from the API
 * This provides the most natural and intuitive streaming experience
 */
export const StreamingText = ({ text, children, }) => {
    // REAL STREAMING: Display text directly as it arrives from API
    // React will re-render each time `text` prop changes (each chunk from Claude)
    // This creates the natural streaming effect users expect
    useEffect(() => {
        // Debug log removed for cleaner console
    }, [text]);
    // If children is provided, render it with current text
    if (children) {
        return _jsx(_Fragment, { children: children(text) });
    }
    // Otherwise return plain text directly
    // React will re-render this component each time text prop changes
    return _jsx(_Fragment, { children: text });
};
